import { createStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    bigImage: {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    blogPostPanel: {
      breakInside: "avoid",
      padding: "5px",
    },
    blogPost: {
      padding: "10px",
    },
    blogPostContainer: {
      columnCount: 2,
      columnGap: 0,
    },
    blogTitle: {
      fontFamily: "Roboto",
      fontSize: "64px",
      fontWeight: 900,
      fontStyle: "normal",
      fontStretch: "normal",
      lineHeight: 1.25,
      letterSpacing: "normal",
      color: "#000000",
      padding: "0 20px",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    componentContainer: {
      background: "white",
    },
    minHeightContainer: {
      minHeight: window.innerHeight * 0.7,
      flexDirection: "column",
    },
    hideOnMobile: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    hideOnDesktop: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    paperContent: {
      margin: "2rem",
    },
    supportEntryContainer: {
      "& h1": {
        fontSize: 36,
        fontWeight: 900,
        marginBottom: 30,
        marginTop: 0,
      },
      "& .iframeContainer": {
        width: "100%",
        height: 500,
        marginBottom: 20,
      },
    },
    mainContentContainer: {
      width: 1200,
      marginTop: 40,
      [theme.breakpoints.down(1440)]: {
        width: 940,
      },
      [theme.breakpoints.down(992)]: {
        width: `calc(100% - 6% - 80px)`,
      },
      [theme.breakpoints.down("xs")]: {
        marginTop: 0,
        width: "100%",
      },
    },
    supportMenu: {
      width: "25%",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        borderBottom: "1px solid rgba(68, 85, 103, 0.11)",
      },
    },
    supportContent: {
      width: "70%",
      paddingRight: 40,
      [theme.breakpoints.down("xs")]: {
        width: "90%",
        marginLeft: "5%",
        paddingRight: 10,
      },
      "& h3": {
        fontSize: 24,
        fontWeight: 500,
        marginTop: 20,
        marginBottom: 15,
      },
      "& p": {
        lineHeight: 1.6,
      },
      "& img": {
        objectFit: "contain",
        height: "auto",
      },
      "& blockquote p": {
        overflow: "scroll",
      },
      "& code": {
        [theme.breakpoints.down("xs")]: {
          fontSize: 10,
        },
      },
    },
    ctaBlock: {
      marginTop: 20,
      marginBottom: 20,
    },
    submenu: {
      whiteSpace: "initial",
      "&:hover": {
        fontWeight: 500,
      },
    },
    selectedSubmenu: {
      whiteSpace: "initial",
      fontWeight: 800,
      color: "#ED6B6A",
    },
    menuItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "&:hover": {
        fontWeight: 500,
      },
    },
    selectedMenuItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 800,
      color: "#ED6B6A",
    },
    searchContainer: {
      width: "100%",
      marginBottom: 20,
      display: "flex",
      justifyContent: "flex-end",
      position: "relative",
    },
    searchInput: {
      width: 360,
      [theme.breakpoints.down("xs")]: {
        width: "90%",
        marginTop: 10,
        marginRight: 10,
      },
    },
    resultEntriesContainer: {
      "& h1": {
        marginTop: 0,
      },
    },
    resultEntryContainer: {
      cursor: "pointer",
      "&:hover": {
        fontWeight: 800,
      },
    },
    resultTitle: {
      fontSize: 18,
      marginBottom: 0,
    },
    resultCategory: {
      color: "#ED6B6A",
      marginBottom: 20,
    },
    searchIcon: {
      position: "absolute",
      right: 10,
      top: 6,
      cursor: "pointer",
      [theme.breakpoints.down("xs")]: {
        right: 20,
        top: 16,
      },
    },
  });

export default styles;
